import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
var RubriqPlagiarismHeader = function RubriqPlagiarismHeader(_ref) {
  var loadingCheckDocumentModal = _ref.loadingCheckDocumentModal,
    onCheckDocument = _ref.onCheckDocument;
  return /*#__PURE__*/React.createElement("div", {
    className: "rounded-3-flex justify-content-between align-items-center justify-content-md-end"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "mt-2 mb-4 btn btn-primary rounded-3",
    onClick: function onClick() {
      return onCheckDocument();
    },
    disabled: loadingCheckDocumentModal
  }, /*#__PURE__*/React.createElement(T, {
    source: "check document"
  }), loadingCheckDocumentModal && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  })));
};
export default RubriqPlagiarismHeader;